import React from 'react';
import Icon from '@ant-design/icons';

const EditSVG = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <title>Icon / Edit</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Icon-/-Edit" stroke="currentColor">
        <line x1="8" y1="15.5" x2="15" y2="15.5" id="Path" />
        <path
          d="M12.0388371,1.50808796 C12.4770368,1.06988833 13.1157266,0.898751893 13.7143185,1.05914409 C14.3129103,1.21953629 14.7804637,1.68708972 14.9408559,2.28568155 C15.1012481,2.88427337 14.9301117,3.52296325 14.491912,3.96116287 L4.27076656,14.1823084 L1,15 L1.81769164,11.7292334 L12.0388371,1.50808796 Z"
          id="Path"
        />
      </g>
    </g>
  </svg>
);

export const JEdit: React.FC<any> = (props) => {
  return <Icon component={EditSVG} {...props}  aria-hidden={true}/>;
};
